<div class="background">
  <div class="paper">
    <!-- Story Content -->
    <div *ngIf="storyContent$ | async as storyContent">
      <div
        [innerHTML]="storyContent.text"
        [style.text-align]="storyContent.alignment"
        class="story-content">
      </div>
    </div>

    <!-- Bodies Subcollection -->
    <div *ngIf="bodiesContent$ | async as bodiesContent">
      <div *ngFor="let bodyContent of bodiesContent" class="body-item">
        <div
          [innerHTML]="bodyContent.text"
          [style.text-align]="bodyContent.alignment">
        </div>
      </div>
    </div>

    <!-- Powered By Section -->
    <div class="powered-by">
      Made with Teris.id ⚡ 
    </div>
  </div>
</div>